import React from 'react';
import './index.scss';

import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import CheckBoxInput from 'components/atoms/Input/CheckBoxInput';
import RadioInput from 'components/atoms/Input/RadioInput';
import TextInput from 'components/atoms/Input/TextInput';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import CalendarInput from 'components/atoms/Input/CalendarInput';
import PcSkillLevel from 'components/molecules/PcSkillLevel';
import PcAccordionInput from 'components/molecules/PcAccordionInput';
import PcErrorArea from 'components/molecules/PcErrorArea';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import PcPopUp from 'components/molecules/PcPopUp';
import PcHowToDo from 'components/molecules/PcHowToDo';
import PcSuggestList from 'components/molecules/PcSuggestList';

const PcInputTitle = ({
  title,
  label,
  questionMark,
  popUpTitle,
  popUpDetail,
  subTitle,
  list = [],
  type,
  isLine, // 点線が無しの場合はfalseを設定する
  selectedDate,
  errorDispMessages,
  comment,
  radioChild,
  childInput,
}) => {
  const DispTitle = () => {
    return Array.isArray(title)
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  const DispSubTitle = () => {
    return Array.isArray(subTitle)
      ? subTitle.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{subTitle}</>;
  };

  const editPopUpDetail = (popUpLines) => {
    return (
      <span>
      <p>
        {Array.isArray(popUpLines)? popUpLines.map(line => (<span key={line}>{line}<br /></span>)) : <>{popUpLines}</>}
      </p>
    </span>
    )
  };

  return (
    <div className="PcInputTitle">
      <div className="PITM-title">
        <DispTitle />
        {<RequiredOrOptionalIcon label={label} />}
        {questionMark && <PcPopUp title={popUpTitle} children={editPopUpDetail(popUpDetail)}/>}
      </div>

      {subTitle !== null && subTitle !== '' ? <div className="PITM-subTitle"> <DispSubTitle /> </div>: <></>}

      { type === "TitleOnly" ? <></> :
        <div className="PITM-item">
          <DispList type={type} list={list} selectedDate={selectedDate} comment={comment} radioChild={radioChild} childInput={childInput} />
          <div className="PITM-ERR">
            <PcErrorArea position='relative' message={errorDispMessages} />
          </div>
          <>
            {isLine ? <div className="horizontalLine" /> : <div />}
          </>
        </div>
      }
    </div>
  );
};

export default PcInputTitle;

const DispList = (prop) => {
  switch (prop.type) {
    case 'CheckBoxInput': return (
      <CheckList list={prop.list} />
    ); break;
    case 'SkillLevel': return (
      <SkillList list={prop.list} />
    ); break;
    case 'BasicCheckBoxInput': return (
      <BasicCheckList list={prop.list} comment={prop.comment}/>
    ); break;
    case 'BasicCheckBoxOnly': return (
      <BasicCheckBoxOnly list={prop.list} comment={prop.comment}/>
    ); break;
    case 'RadioInput': return (
      <RadioInputList list={prop.list} selectedDate={prop.selectedDate} comment={prop.comment}/>
    ); break;
    case 'TextInput': return (
      <TextInputList list={prop.list} />
    ); break;
    case 'TextAreaInput': return (
      <TextAreaInputList list={prop.list} />
    ); break;
    case 'FreeInput': return (
      <FreeInputList list={prop.list} />
    ); break;
    case 'RadioChidInput': return (
      <RadioInputWithRadioChidList list={prop.list} radioChild={prop.radioChild}/>
    ); break;
    case 'CheckBoxChildInput': return (
      <CheckBoxInputWithChildList list={prop.list} childInput={prop.childInput} />
    ); break;
    case 'HowToDo': return (
      <HowToDo list={prop.list} />
    ); break;
    default: return null;
  }
};

const radioWidth = ( pNumber ) => ({
  width: `calc(100% / ${pNumber} - 10px)`,
});

const CheckList = ({ list: detail }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="" key={data.id}>
          <CheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ),
      )}
    </div>
  );
};

const SkillList = ({ list: detail }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="" key={data.id}>
          <PcSkillLevel
            id={data.id}
            name={data.name}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            level={data.level}
            salary={data.salary}
            skill={data.skill}
          />
        </span>
      ))}
    </div>
  );
};

const BasicCheckList = ({ list: detail, comment }) => {
  return (
    <div className="">
      {detail.map(data => (
        <span className="PcInputTitle basicCheckBox" style={radioWidth(data.number)} key={data.id}>
          <BasicCheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            disabled={data.disabled}
            label={data.label}
          />
        </span>
      ),
      )}
      <div className="commentArea">{comment}</div>
    </div>
  );
};

const BasicCheckBoxOnly = ({ list: data, comment }) => {
  return (
    <div className="">
      <BasicCheckBoxInput
        id={data.id}
        value={data.value}
        onChange={data.onChange}
        checked={data.checked}
        disabled={data.disabled}
        label={data.label}
      />
      <div className="commentArea">{comment}</div>
    </div>
  );
};
const TextInputList = ({ list: detail }) => {
  return (
    <div className="">
      <span className="PcInputTitle TextInput">
        {detail.map(data => (
          <span key={data.name}>
            <TextInput
              name={data.name}
              val={data.value}
              onChange={data.onChange}
              onInput={data.onInput}
              onCompositionEnd={data.onCompositionEnd}
              maxLength={data.maxLength}
              placeholder={data.placeholder}
              inValid={data.inValid}
            />
            {
              !!data.suggestList ?
                <PcSuggestList
                  items={data.suggestList.items}
                  onClick={data.suggestList.onClick}
                />
                :
                <></>
            }
          </span>
        ))}
      </span>
    </div>
  );
};
const TextAreaInputList = ({ list: detail }) => {
  return (
    <div className="">
      <span className="PcInputTitle TextAreaInput">
        {detail.map(data => (
          <span key={data.name}>
            <TextAreaInput
              name={data.name}
              value={data.value}
              onChange={data.onChange}
              onInput={data.onInput}
              onCompositionEnd={data.onCompositionEnd}
              maxLength={data.maxLength}
              rows={data.rows}
              cols={data.cols}
              placeholder={data.placeholder}
              inValid={data.inValid}
            />
            <div className='word-count'>{data.wordCount}</div>
          </span>
        ))}
      </span>
    </div>
  );
};
const FreeInputList = ({ list: detail }) => {
  return (
    <div className="">
      {detail}
    </div>
  );
};


const today = new Date();
const tommorow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

const RadioInputList = ({ list: detail, selectedDate, comment }) => {
  return (
    <>
      {detail.map((data) => (
        <span className="PcInputTitle radioInput" style={radioWidth(data.number)} key={data.id}>
          {
            !data.isCalendarRadio ? (
              <RadioInput
                id={data.id}
                name={data.name}
                value={data.value}
                onChange={data.onChange}
                checked={data.checked}
                label={data.label}
              />
            )
              : (
                <CalendarInput 
                  minDate={tommorow}
                  selected={selectedDate}
                  radioInput={data}
                  label={data.label}
                />
              )
          }
        </span>
      ),
      )}
      <div className="commentArea">{comment}</div>
    </>
  );
};

const RadioInputWithRadioChidList = ({ list: detail, radioChild }) => {
  return (
    <>
      {detail.map((data) => (
        <span className="PcInputTitle radioInput" style={radioWidth(data.number)} key={data.id}>
          <RadioInput
            id={data.id}
            name={data.name}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ))}

      {!radioChild ? (<></>) : (
        <>
          <div className="radioChidArea">
            <PcAccordionInput
              title={radioChild.title}
              label={radioChild.label}
              list={radioChild.list}
              type={radioChild.type}
              visible={radioChild.visible}
            />
          </div>
        </>
      )}
    </>
  );
};
const CheckBoxInputWithChildList = ({ list: detail, childInput }) => {
  return (
    <>
      {detail.map(data => (
        <span className="PcInputTitle basicCheckBox" style={radioWidth(data.number)} key={data.id}>
          <BasicCheckBoxInput
            id={data.id}
            value={data.value}
            onChange={data.onChange}
            checked={data.checked}
            label={data.label}
          />
        </span>
      ),
      )}
      {!childInput ? (<></>) : (
        <>
          <div className="childArea">
            <PcAccordionInput
              title={childInput.title}
              label={childInput.label}
              list={childInput.list}
              type={childInput.type}
              visible={childInput.visible}
            />
          </div>
        </>
      )}
    </>
  );
};

const HowToDo = ({ list: detail }) => {
  return (
    <span className="">
      {detail.map(data => (
        <span className="" key={data.id}>
          <PcHowToDo
            value={data.value}
            checked={data.checked}
            label={data.label}
            subLabel={data.subLabel}
            point={data.point}
            icon={data.icon}
            onChange={data.onChange}
            id={data.id}
          />
        </span>
      ))}
    </span>
  );
};
